import { render, staticRenderFns } from "./JBrowse.vue?vue&type=template&id=3ff5071c&scoped=true&"
import script from "./JBrowse.vue?vue&type=script&lang=js&"
export * from "./JBrowse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff5071c",
  null
  
)

export default component.exports